import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ErrorPage from "./error-page";
import {
  Typography,
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ChatHeader = () => {
  useEffect(() => {
    document.title = "Booking";
  }, []);

  return (
    <Typography variant="h4" align="center" gutterBottom>
      User List
    </Typography>
  );
};


const SessionList = ({ sessions, selectedUserType, onDeleteUser, onEditUser, statusbutton }) => {
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [selectedUserSchedule, setSelectedUserSchedule] = useState([]);


  const handleViewSchedule = async (user) => {
    try {
      const scheduleData = await fetchScheduleData({
        user_id: parseInt(user.id, 10),
        user_type: user.user_type,
      });

      setSelectedUserSchedule(scheduleData);
      setScheduleModalOpen(true);
    } catch (error) {
      console.error("Error fetching schedule data:", error.message);
    }
  };
  // Filter sessions based on selectedUserType
  const filteredSessions = selectedUserType
    ? sessions.filter(session => session.user_type.toString() === selectedUserType)
    : sessions;


  return (
    <div style={{ textAlign: 'left' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>User Name</TableCell>
            <TableCell>Key</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredSessions.map((sessionElement) => (
            <TableRow key={sessionElement.id}>
              <TableCell>{sessionElement.id}</TableCell>
              <TableCell>{sessionElement.user_name}</TableCell>
              <TableCell>{sessionElement.key}</TableCell>
              <TableCell>
                {/* Conditionally render dot based on user_status */}
                {sessionElement.user_status === 1 ? (
                  <span style={{ color: 'green', marginRight: '5px' }}>●</span>
                ) : (
                  <span style={{ color: 'red', marginRight: '5px' }}>●</span>
                )}
                {/* Display user status text */}
                {sessionElement.user_status === 1 ? 'Active' : 'Disabled'}
              </TableCell>
              <TableCell>
                {sessionElement.user_status === 0 && (
                  <Button
                    variant="outlined"
                    onClick={() => statusbutton(sessionElement)}
                  >
                    Enable
                  </Button>
                )}
                {sessionElement.user_status === 1 && (
                  <Button
                    variant="outlined"
                    onClick={() => statusbutton(sessionElement)}
                  >
                    Disable
                  </Button>
                )}
                <Button variant="outlined" onClick={() => onEditUser(sessionElement)}>
                  Edit
                </Button>
                <Button variant="outlined" color="error" onClick={() => onDeleteUser(sessionElement)}>
                  Delete
                </Button>
                <Button variant="outlined" onClick={() => handleViewSchedule(sessionElement)}>
                  View Schedule
                </Button>
              </TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
      <ScheduleModal
        open={scheduleModalOpen}
        onClose={() => setScheduleModalOpen(false)}
        scheduleData={selectedUserSchedule}
      />
    </div>
  );
};


const UserTypeSelector = ({ selectedUserType, setSelectedUserType }) => {
  return (
    <select
      value={selectedUserType}
      onChange={(e) => setSelectedUserType(e.target.value)}
    >
      <option value="">All</option>
      <option value="1">Student</option>
      <option value="2">Teacher</option>
    </select>
  );
};
const ScheduleModal = ({ open, onClose, scheduleData }) => {
  console.log('Modal Schedule Data:', scheduleData);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Schedule</DialogTitle>
      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Student1</TableCell>
              <TableCell>Student2</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {scheduleData.map((scheduleItem) => (
              <TableRow key={scheduleItem.id}>
                <TableCell>{scheduleItem.date}</TableCell>
                <TableCell>{scheduleItem.time}</TableCell>
                <TableCell>{scheduleItem.student1}</TableCell>
                <TableCell>{scheduleItem.student2}</TableCell>
                {scheduleItem.booking_status === 1 && (
                  <TableCell>
                    <Button
                      variant="outlined"
                      disabled
                    >
                      Booked
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const fetchScheduleData = async ({ user_id, user_type }) => {
  console.log('Fetching Schedule Data for User ID:', user_id);
  try {
    const apiUrl = `/api/get_schedule`;

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id,
        user_type, // Include user_type in the request body
      }),
    });

    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(`Error fetching schedule data: ${response.status} - ${errorMessage}`);
    }

    const scheduleData = await response.json();
    console.log('Fetched Schedule Data:', scheduleData);
    return scheduleData;
  } catch (error) {
    console.error('Error fetching schedule data:', error.message);
    throw error;
  }
};


function App() {
  const [sessions, setSessions] = useState([]);
  // const [userExists, setUserExists] = useState(false);
  // const [userCredentials, setUserCredentials] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState('');
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const { user_id, user_name, user_key, user_type } = useParams();
  // const { userParams } = useParams();
  const [registrationModalOpen, setRegistrationModalOpen] = useState(false);
  const [userName, setUserName] = useState('');
  const [userType, setUserType] = useState('1'); // Default to '1' (student)
  const [registrationSuccessMessage, setRegistrationSuccessMessage] = useState('');
  const [registrationErrorMessage, setRegistrationErrorMessage] = useState('');
  const [registrationValidationError, setRegistrationValidationError] = useState('');
  const [editingUser, setEditingUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  // let user_id, user_name, user_key, user_type

  useEffect(() => {
    if (typeof user_id === 'string'
      && typeof user_name === 'string'
      && typeof user_key === 'string'
      && typeof user_type === 'string') {
      console.log(1)
    } else {
      console.log('invalid user_id');
      return;
    }
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const apiUrl = "/api/get_user_credentials";

  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           id,
  //           user_name,
  //           key,
  //           user_type
  //         }),
  //       });

  //       if (!response.ok) {
  //         throw new Error(`Error fetching user credentials: ${response.status} - ${response.statusText}`);
  //       }

  //       const result = await response.json();
  //       setUserCredentials(result);

  //       const checkUserUrl = "/api/check_user";


  //       const checkUserResponse = await fetch(checkUserUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           id: result.id,
  //           user_name: result.user_name,
  //           key: result.key,
  //           user_type: result.user_type,
  //         }),
  //       });

  //       if (!checkUserResponse.ok) {
  //         throw new Error(`Error checking user existence: ${checkUserResponse.status} - ${checkUserResponse.statusText}`);
  //       }

  //       const userExistsResult = await checkUserResponse.json();
  //       setUserExists(userExistsResult.exists);
  //     } catch (error) {
  //       console.error("Error:", error.message);
  //     }
  //   };

  //   fetchData();
  // }, [id, user_name, key, user_type, selectedUserType]);


  // const handleGetData = (dataType = '', user_id = '', user_name = '', user_key = '', user_type = '', user_status = '') => {
  //   console.log("Selected User Type:", selectedUserType); // Add this line

  //   const apiUrl = "/api/users_handler";

  //   let bodyMsg = {
  //     data_type: dataType,
  //     user_id: user_id,
  //     user_name: user_name,
  //     user_key: user_key,
  //     user_type: user_type,
  //     user_status: user_status,
  //     selectedUserType: selectedUserType,
  //   };

  //   const requestOptions = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(bodyMsg),
  //   };

  //   fetch(apiUrl, requestOptions)
  //     .then((api_response) => api_response.json())
  //     .then((data) => {
  //       console.log("API Response:", data);

  //       if (data.data) {
  //         let response = data.data;

  //         if (dataType === 'user_list') {
  //           setSessions(response);
  //         } else {
  //           console.log('dataType not user_list' + dataType);
  //         }
  //       } else {
  //         console.error("API Error:", data.error);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };
  const handleGetData = () => {
    console.log("Selected User Type:", selectedUserType); // Add this line
    console.log("user_id, user_name, user_key, user_type" + user_id + " " + user_name + " " + user_key + " " + user_type);

    const apiUrl = "/api/users_handler";

    let bodyMsg = {
      user_id: user_id,
      user_name: user_name,
      user_key: user_key,
      user_type: user_type,
      selectedUserType: selectedUserType,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyMsg),
    };

    fetch(apiUrl, requestOptions)
      .then((api_response) => api_response.json())
      .then((data) => {
        console.log("API Response:", data);

        if (data.data) {
          setSessions(data.data);
        } else {
          console.error("API Error:", data.error);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleDeleteUser = (user) => {
    setUserToDelete(user);
    setConfirmationDialogOpen(true);
  };
  const handleConfirmDelete = async () => {
    try {
      // Ensure userToDelete is not null before proceeding
      if (!userToDelete) {
        console.error("No user selected for deletion");
        return;
      }

      const apiUrl = "/api/delete_user";
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: userToDelete.id,
          // Add other properties if needed for deletion
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Server Error:", errorData);
        throw new Error(`Error deleting user: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      console.log(result.message); // Log success message

      // Refresh the user list or perform any additional actions if needed
      // handleGetData('user_list', id.toString()); // Refresh the user list
      handleGetData('user_list', user_id);

      // Close the confirmation dialog and reset userToDelete
      setConfirmationDialogOpen(false);
      setUserToDelete(null);
    } catch (error) {
      console.error("Error deleting user:", error.message);
    }
  };


  const handleCancelDelete = () => {
    // Close the confirmation dialog and reset userToDelete
    setConfirmationDialogOpen(false);
    setUserToDelete(null);
  };


  const userstatusbutton = async (sessionElement) => {
    try {
      const newStatus = sessionElement.user_status === 1 ? 0 : 1;

      const apiUrl = "/api/toggle_user_status";
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: sessionElement.id,
          user_status: newStatus,
        }),
      });
      console.log("Full Response:", response);

      // Check if the response has already been processed
      if (response.bodyUsed) {
        console.log("Response already processed");
        return;
      }

      let jsonData;
      try {
        jsonData = await response.json();
        console.log("API Response:", jsonData);

        // Process the response data
        if (!response.ok) {
          throw new Error("Server Error");
        }

        if (jsonData.message) {
          // Handle success
          console.log(jsonData.message);
        } else {
          // Handle error
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error processing JSON:", error.message);
      }

      // Refresh the user list
      // handleGetData('user_list', id.toString());
      handleGetData('user_list', user_id);
    } catch (error) {
      console.error("Error toggling user status:", error.message);
    }
  };



  const handleOpenRegistrationModal = () => {
    setRegistrationModalOpen(true);
  };
  const handleRegisterUser = async () => {
    // Validate that the username is not empty
    if (!userName.trim()) {
      setRegistrationValidationError('Please enter a username.');
      return;
    }

    console.log("Registering user...");

    const userData = {
      user_name: userName,
      user_type: userType,
    };

    console.log("Request Payload:", JSON.stringify(userData));

    try {
      const apiUrl = "/api/register_user";
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        const errorData = await response.json();

        // Check if the error status code is 400 (Bad Request)
        if (response.status === 400 && errorData.detail === "User with this username already exists") {
          // Handle the case where the username already exists
          console.error("Username already exists");
          setRegistrationErrorMessage('Username already exists');
          setRegistrationSuccessMessage('');
          setRegistrationValidationError('');
          return;
        } else {
          // Handle other errors
          console.error("Server Error Details:", errorData);
        }

        throw new Error(`Error registering user: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      console.log(result.message); // Log success message

      // Set success message and clear other messages
      setRegistrationSuccessMessage(result.message);
      setRegistrationErrorMessage('');
      setRegistrationValidationError('');

      // Clear the username field
      setUserName('');

      // Refresh the user list or perform any additional actions if needed
      // handleGetData('user_list', id.toString()); // Refresh the user list
      handleGetData('user_list', user_id);
    } catch (error) {
      console.error("Error registering user:", error.message);
      console.error("Error registering user:", error.message);
      // Set error message and clear success message
      setRegistrationSuccessMessage('');
      setRegistrationErrorMessage('User Already Exist');
      setRegistrationValidationError('');
    }
  };


  const handleEditUser = (user) => {
    setEditingUser(user);
    // setUserName(userName); // Set the initial username for editing
    setIsEditing(false); // Set to false to show "Regenerate Key" button by default
  };
  const handleUsernameClick = () => {
    setIsEditing(true); // Set to true when the username is clicked
  };

  const handleSaveEdit = async () => {
    try {
      const apiUrl = "/api/update_user";
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: editingUser.id,
          user_name: editingUser.user_name,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Server Error:", errorData);

        if (errorData.detail && Array.isArray(errorData.detail)) {
          console.error("Validation Error details:", errorData.detail);
        }

        throw new Error(`Error updating user: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      console.log(result.message); // Log success message

      setEditingUser(null);
      setIsEditing(false); // Reset editing state

      // Refresh the user list after saving the edit
      // handleGetData('user_list', id.toString());
      handleGetData('user_list', user_id);
    } catch (error) {
      console.error("Error updating user:", error.message);
    }
  };

  const handleCancelEdit = () => {
    // Cancel the edit
    setEditingUser(null);
    setIsEditing(false); // Reset editing state
  };



  // if (userCredentials && userExists && user_type === '0') {
  return (
    <>
      <ChatHeader />
      <div>
          <div>

            <div style={{ display: 'flex', gap: '8px' }}>
              <Button
                variant="contained"
                onClick={() => {
                  handleGetData();
                  // handleGetData('user_list', id.toString());
                }}
              >
                Get users
              </Button>

              <Button
                variant="contained"
                onClick={handleOpenRegistrationModal}
              >
                Register User
              </Button>
            </div><Dialog open={registrationModalOpen} onClose={() => setRegistrationModalOpen(false)}>
              <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Register User
                <IconButton onClick={() => setRegistrationModalOpen(false)} color="inherit">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                {registrationErrorMessage && (
                  <div style={{ color: 'red', marginBottom: '10px' }}>
                    {registrationErrorMessage}
                  </div>
                )}
                {registrationSuccessMessage && (
                  <div style={{ color: 'green', marginBottom: '10px' }}>
                    {registrationSuccessMessage}
                  </div>
                )}
                {registrationValidationError && (
                  <div style={{ color: 'red', marginBottom: '10px' }}>
                    {registrationValidationError}
                  </div>
                )}
                <div>
                  <label>Username: </label>
                  <input
                    type="text"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>
                <div>
                  <label>User Type: </label>
                  <select
                    value={userType}
                    onChange={(e) => setUserType(e.target.value)}
                  >
                    <option value="1">Student</option>
                    <option value="2">Teacher</option>
                  </select>
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleRegisterUser} variant="contained">
                  Register
                </Button>
                <Button onClick={() => setRegistrationModalOpen(false)} variant="outlined">
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>


            <div style={{ marginLeft: 1, marginTop: 5 }} />
            <UserTypeSelector
              selectedUserType={selectedUserType}
              setSelectedUserType={setSelectedUserType}
            />
            <SessionList
              sessions={sessions}
              selectedUserType={selectedUserType}
              onDeleteUser={handleDeleteUser}
              statusbutton={userstatusbutton}
              onEditUser={handleEditUser}
            />
            <Dialog open={confirmationDialogOpen} onClose={handleCancelDelete}>
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                Are you sure you want to delete the user?
              </DialogContent>
              <DialogActions>
                <Button onClick={handleConfirmDelete} variant="contained">
                  Confirm
                </Button>
                <Button onClick={handleCancelDelete} variant="outlined">
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={Boolean(editingUser)} onClose={handleCancelEdit}>
              <DialogTitle>Edit User</DialogTitle>
              <DialogContent>
                <TextField
                  label="User Name"
                  value={editingUser ? editingUser.user_name : ''}
                  onClick={handleUsernameClick} // Add this line to handle the click event
                  onChange={(e) => setEditingUser({ ...editingUser, user_name: e.target.value })}
                  fullWidth
                  style={{ marginTop: '10px' }}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleSaveEdit} variant="contained">
                  {isEditing ? 'Save' : 'Regenerate Key'}
                </Button>
                <Button onClick={handleCancelEdit} variant="outlined">
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>


    </>
  );
  // } else {
  //   return <div><ErrorPage /></div>;
  // }
}
export default App;
